import { AfterViewInit, Component, DoCheck, EventEmitter, Input, Output } from '@angular/core';
import { ChecklistRule } from './models/checklist-rule';
import { FormGroup } from '@angular/forms';
import { startWith } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ft-validation-checklist',
    templateUrl: './validation-checklist.component.html',
    styleUrls: ['./validation-checklist.component.scss'],
    standalone: false
})
export class ValidationChecklistComponent implements DoCheck, AfterViewInit {
    @Input() rules: ChecklistRule[] = [];
    @Input() title: string;
    @Input() summary: string;
    @Input() isValid: boolean;
    @Input() activeFormGroup: FormGroup;
    @Input() alwaysVisible = true;
    @Output() isValidChange = new EventEmitter<boolean>();

    ngDoCheck() {
        if (!this.activeFormGroup) {
            this.checkIsValid();
        }
    }

    ngAfterViewInit() {
        if (this.activeFormGroup) {
            this.activeFormGroup?.valueChanges
                .pipe(
                    startWith(null),
                    untilDestroyed(this)
                )
                .subscribe(() => {
                    this.checkIsValid();
                });
        }
    }

    checkIsValid() {
        const isValid = this.rules?.every(rule => this.activeFormGroup?.controls?.[rule?.formControlName]?.valid || rule?.isValid) || false;
        if (this.isValid !== isValid) {
            this.isValidChange.emit(isValid);
        }
        this.isValid = isValid;
    }
}
